<template>
  <v-container fluid grid-list-xl class="pa-0">
    <v-layout column wrap align-center class="pt-3 pb-3">
      <div class="headline">{{ section.top.title }}</div>
      <div class="subtitle-1">
        {{ section.top.subtitle }}
      </div>
    </v-layout>

    <div class="separator" />

    <v-layout column wrap align-center class="pt-2 pb-2">
      <div class="headline">{{ section.middle.title }}</div>
      <div class="subtitle-1">
        {{ section.middle.subtitle }}
      </div>
    </v-layout>

    <div class="separator" />

    <v-layout row justify-space-between class="pt-3 pb-3 ml-3 mr-3">
      <div
        v-for="section in section.bottom.subtitle"
        :key="section"
        class="subtitle-1"
      >
        {{ section }}
      </div>
    </v-layout>

    <div class="separator" />
  </v-container>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      default: function() {
        return {
          top: {},
          middle: {},
          bottom: {}
        };
      }
    }
  }
};
</script>

<style scoped>
.separator {
  border-bottom: solid lightgray 1px;
}
</style>
